

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import MatomoEvents from '@/matomo/events/MatomoEvents';

@Component
export default class OrderTemplatePdfButton extends Vue {
  public open: boolean = false;

  @Prop({required: false, default: 'pdf'})
  public localAction: string;

  @Prop({ required: false, default: 'true' })
  public localAllowImages: string;

  @Prop({ required: false, default: 'false'})
  public localRenderOption: string;

  public generateButtonClicked() {
    MatomoEvents.forOrderTemplates.downloadPdf.publish();
    this.handleOutsideClick();
  }

  public handleOutsideClick() {
    this.open = false;
    window.removeEventListener('click', this.handleOutsideClick);
  }

  public openDialogWrapper() {
    this.open = true;
    window.addEventListener('click', this.handleOutsideClick);
  }

  public get allowImages() {
    return this.localAllowImages === 'true';
  }

  public emitOptionsToggle() {
    this.$emit('optionsToggle');
  }
}
